export default __webpack_public_path__ + "static/media/SDG1.0cd930b3.png";